module.exports = __webpack_public_path__ + "img/k.b6119aec.jpg";